<script setup lang="ts">
import logoutSmall from "assets/graphics/icons/cb_logout_small.svg";
import NavBarLink from "~/components/NavBarLink.vue";
import { signOutUser } from "~/composables/useFirebase";
import { useCurrentCareDay } from "~/composables/useStates";
import { FacilityFirestore } from "~/types/facility";

const currentCareDay = useCurrentCareDay();
const facilityStore = useFacilityStore();
const facilityStoreRefs = storeToRefs(facilityStore);
const facility: Ref<FacilityFirestore | null> = facilityStoreRefs.facility;

const route = useRoute();

const handleLogout = () => {
  signOutUser()
    .then(() => {
      localStorage.removeItem("currentCareDay");
      navigateTo("/login");
    })
    .catch((error) => {
      console.log(error);
    });
};
</script>

<template>
  <div class="top-header-bar">
    <div class="top-header-bar-wrapper">
      <h1 class="facility-name-top">
        {{ route.path !== "/" ? facility?.title : "" }}
      </h1>
      <div class="top-links">
        <NavBarLink
          :text="$t('navigation.main_news')"
          icon="info_circle"
          :is-chip="true"
          to="/news"
          class="top-link top-link-spacing"
        />
        <NavBarLink
          :text="$t('navigation.help')"
          icon="helpSmall"
          :is-chip="true"
          to="/manuals"
          class="top-link top-link-spacing"
        />
        <NavBarLink
          :text="$t('navigation.settings')"
          icon="settingsSmall"
          :is-chip="true"
          to="/settings"
          class="top-link top-link-spacing"
        />
        <NavBarLink
          :text="$t('navigation.overview')"
          icon="homeSmall"
          :is-chip="true"
          to="/"
          class="top-link top-link-spacing"
        />
        <a
          class="cb_nav-link d-flex logout-btn top-link-spacing"
          @click="handleLogout"
        >
          <img :src="logoutSmall"></a>
      </div>
    </div>
    <h2 class="top-header-bar-subtitle">
      {{ route.path !== "/" ? currentCareDay?.name : "" }}
    </h2>
  </div>
</template>

<style scoped>
.facility-name-top {
  font-size: 2rem;
  font-weight: 900;
}

.top-header-bar {
  margin-top: 1.75rem;
}

.top-header-bar-wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
}

.top-links {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.top-link {
  color: #000f28;
}

.logout-btn {
  padding: 0.5rem 0.75rem;
}
</style>
